var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashCanBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.69231V2.23077C0 1.67848 0.447715 1.23077 1 1.23077H3.69231L4.63018 0.292893C4.81772 0.105357 5.07207 0 5.33729 0H9.43194C9.69716 0 9.95151 0.105357 10.139 0.292893L11.0769 1.23077H13.7692C14.3215 1.23077 14.7692 1.67848 14.7692 2.23077V2.69231C14.7692 3.24459 14.3215 3.69231 13.7692 3.69231H1C0.447716 3.69231 0 3.24459 0 2.69231ZM13.5385 4.92308H1.23077L2.26386 14.2209C2.3764 15.2337 3.23252 16 4.25162 16H10.5176C11.5367 16 12.3928 15.2337 12.5054 14.2209L13.5385 4.92308Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashCanBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash-can-black.972171e7b90797b270d641bb435ac54a.svg";